import './mediaGallery.scss'
import { Gallery, Item } from 'react-photoswipe-gallery'
import 'photoswipe/style.css';
import type { Media } from '../../../interfaces/media';

export default function MediaGallery({list}:{list:Media[]}){
    if(list==undefined || list.length === 0){
        return(
            <div>Aucun média</div>
        )
    }

    return(
        <>
        <div className="media-image-container grid col-3">
            <Gallery withCaption={true}>
                {
                    list.map((media : Media,index:number) =>
                    <Item key={index}
                        original={media.original}
                        thumbnail={media.thumbnail}
                        caption={media.description}
                        width={media.width}
                        height={media.height}>
                        {({ ref, open }) => (
                            <div>
                            <img ref={ref} onClick={open} src={media.thumbnail} className="img-responsive"/>
                            </div>
                        )}
                    </Item>
                    )
                }
            </Gallery>
        </div>
        </>
    )
}